import {CurrentProject} from 'common/report/queries/app-api/project-metadata-client';
import {ProjectDetails} from 'common/report/stores/project-details';
import {ProjectFeatureFlag} from 'common/report/constants';
import {FeatureRolloutName, FeatureRollouts} from 'common/report/util/feature-sampling';

export function canUseMultiAttribution(currentProject?: CurrentProject | ProjectDetails): boolean {
  // Always return true for projects with feature flag enabled
  if (currentProject?.hasFeatureFlag(ProjectFeatureFlag.MultiAttribution)) {
    return true;
  }
  return FeatureRollouts[FeatureRolloutName.MultiAttribution].isEnabled(currentProject);
}

export function canUseMultiAttributionViewUsers(currentProject?: CurrentProject | ProjectDetails): boolean {
  return currentProject?.hasFeatureFlag(ProjectFeatureFlag.MultiAttributionViewUsers, true);
}

export function canUseCountUsersOnceViewUsers(currentProject?: CurrentProject | ProjectDetails): boolean {
  return currentProject?.hasFeatureFlag(ProjectFeatureFlag.UniqueUniquesViewUsers, true);
}

export function canUseMultiAttributionCreateCohort(currentProject?: CurrentProject | ProjectDetails): boolean {
  return currentProject?.hasFeatureFlag(ProjectFeatureFlag.MultiAttributionCreateCohort);
}

export function canUseCountUsersOnceCreateCohort(currentProject?: CurrentProject | ProjectDetails): boolean {
  return currentProject?.hasFeatureFlag(ProjectFeatureFlag.UniqueUniquesCreateCohort);
}

export function canUseMultiAttributionFilter(currentProject?: CurrentProject | ProjectDetails): boolean {
  return FeatureRollouts[FeatureRolloutName.MultiAttributionFilter].isEnabled(currentProject);
}

export function canUseCountUsersOnce(currentProject?: CurrentProject | ProjectDetails): boolean {
  return FeatureRollouts[FeatureRolloutName.UniqueUniques].isEnabled(currentProject);
}
